document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  const header = document.querySelector('[data-header]');
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchOpen = document.querySelector('[data-search-open]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = document.querySelector('[data-search-input]');
  const desktopBreakpoint = 990;
  let searchReturnFocus = null;
  let headerFrame = 0;

  const isPremiumMobileMenuEnabled = () =>
    document.querySelector('[data-aw-header-mobile-settings]')?.dataset.enabled === 'true'
    && nav?.dataset.awMobileController === 'anchor-lock-v2';

  if (nav && !nav.id) nav.id = 'MainNavigation';
  if (toggle && nav) toggle.setAttribute('aria-controls', nav.id);
  if (searchOverlay) {
    if (!searchOverlay.id) searchOverlay.id = 'SearchOverlay';
    searchOpen?.setAttribute('aria-controls', searchOverlay.id);
    searchOpen?.setAttribute('aria-expanded', 'false');
    if (searchInput && !searchInput.getAttribute('aria-label')) searchInput.setAttribute('aria-label', 'Rechercher dans la boutique');
  }

  const getFocusable = (container) => {
    if (!container) return [];
    return [...container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )].filter((element) => !element.hidden && element.getAttribute('aria-hidden') !== 'true');
  };

  const setSubmenuState = (item, open) => {
    if (!item) return;
    const link = item.querySelector(':scope > a');
    link?.setAttribute('aria-expanded', String(open));
    item.classList.toggle('is-menu-open', open && window.innerWidth > desktopBreakpoint);
  };

  const submenuItems = [...document.querySelectorAll('.nav__item.has-submenu')];
  submenuItems.forEach((item, index) => {
    const link = item.querySelector(':scope > a');
    const menu = item.querySelector('.mega-menu');
    if (!link || !menu) return;
    if (!menu.id) menu.id = `MegaMenu-${index + 1}`;
    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-controls', menu.id);
    link.setAttribute('aria-expanded', 'false');

    item.addEventListener('focusin', () => {
      if (window.innerWidth > desktopBreakpoint) setSubmenuState(item, true);
    });
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) setSubmenuState(item, false);
    });
    item.addEventListener('mouseenter', () => {
      if (window.innerWidth > desktopBreakpoint) setSubmenuState(item, true);
    });
    item.addEventListener('mouseleave', () => {
      if (window.innerWidth > desktopBreakpoint) setSubmenuState(item, false);
    });
  });

  const resetMobileMenuScroll = () => {
    if (!nav || window.innerWidth > desktopBreakpoint) return;
    nav.scrollTop = 0;
    requestAnimationFrame(() => {
      nav.scrollTop = 0;
      requestAnimationFrame(() => {
        nav.scrollTop = 0;
      });
    });
  };

  const setMenuState = (open) => {
    if (!toggle || !nav) return;
    nav.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    document.body.classList.toggle('menu-open', open);

    if (!open) {
      submenuItems.forEach((item) => {
        item.classList.remove('submenu-open');
        setSubmenuState(item, false);
      });
    } else if (window.innerWidth <= desktopBreakpoint) {
      resetMobileMenuScroll();
      requestAnimationFrame(() => {
        const first = getFocusable(nav)[0];
        first?.focus({ preventScroll: true });
        nav.scrollTop = 0;
      });
    }
  };

  const setSearchState = (open) => {
    if (!searchOverlay) return;
    searchOpen?.setAttribute('aria-expanded', String(open));

    if (open) {
      searchReturnFocus = document.activeElement;
      setMenuState(false);
      searchOverlay.hidden = false;
      document.body.classList.add('search-open');
      requestAnimationFrame(() => searchInput?.focus());
    } else {
      searchOverlay.hidden = true;
      document.body.classList.remove('search-open');
      searchReturnFocus?.focus?.();
    }
  };

  toggle?.addEventListener('click', () => setMenuState(!nav.classList.contains('is-open')));
  searchOpen?.addEventListener('click', () => setSearchState(true));
  searchClose?.addEventListener('click', () => setSearchState(false));
  searchOverlay?.addEventListener('click', (event) => {
    if (event.target === searchOverlay) setSearchState(false);
  });

  nav?.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (!link || window.innerWidth > desktopBreakpoint) return;

    const parent = link.closest('.has-submenu');
    const isSubmenuTrigger = Boolean(
      parent &&
      parent.firstElementChild === link &&
      parent.querySelector('.mega-menu')
    );

    /* Menu mobile Premium possède son propre contrôleur en capture.
       Quand il est activé, theme.js ne pilote plus les accordéons mobiles. */
    if (isPremiumMobileMenuEnabled() && isSubmenuTrigger) return;

    if (isSubmenuTrigger) {
      event.preventDefault();

      const willOpen = !parent.classList.contains('submenu-open');
      parent.classList.toggle('submenu-open', willOpen);
      setSubmenuState(parent, willOpen);

      /* Important : ne jamais forcer nav.scrollTop vers la catégorie ouverte.
         Le sous-menu doit se développer dans le flux sans aspirer la navigation vers le haut. */
      link.focus({ preventScroll: true });
    } else {
      setMenuState(false);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab' && searchOverlay && !searchOverlay.hidden) {
      const focusable = getFocusable(searchOverlay);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
      return;
    }

    if (event.key !== 'Escape') return;
    if (searchOverlay && !searchOverlay.hidden) {
      setSearchState(false);
    } else if (nav?.classList.contains('is-open')) {
      setMenuState(false);
      toggle?.focus();
    }
  });

  document.addEventListener('click', (event) => {
    if (
      window.innerWidth <= desktopBreakpoint &&
      nav?.classList.contains('is-open') &&
      header &&
      !header.contains(event.target)
    ) {
      setMenuState(false);
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > desktopBreakpoint) setMenuState(false);
  });

  const updateHeader = () => {
    header?.classList.toggle('is-scrolled', window.scrollY > 18);
    headerFrame = 0;
  };
  const requestHeaderUpdate = () => {
    if (headerFrame) return;
    headerFrame = window.requestAnimationFrame(updateHeader);
  };
  updateHeader();
  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
});
